








import Vue from 'vue'
import { $ } from '@/utils/helpers'

export default Vue.extend({
  name: 'EditText',
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    type: {
      type: String,
      default: 'input'
    },
    nextFocusField: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * Enter を押したときの動作
     */
    onKeyDownEnter(event: Event) {
      if (this.type === 'input') {
        event.preventDefault()
        return
      }
    },

    onKeyUpEnter(event) {
      // 次にフォーカスしたいフィールドが指定されていて、存在するなら自動でフォーカスを移す
      if (this.nextFocusField) {
        let nextFied: HTMLElement = $(this.nextFocusField)
        if (nextFied) {
          event.target.blur()
          nextFied.focus()
        }
      }
    },

    handleClick(event) {
      event.target.focus()
      this.$emit('click')
    },

    /**
     * 親の v-model を発火させる
     */
    handleInput(event) {
      this.$emit('input', event.target.value)
    }
  }
})
